/* Sticky-Warenkorb-Button (snippets/ss-sticky-atc.liquid)
   - Erscheint unten, sobald der normale Button nach oben aus dem Bild gescrollt wurde
   - Ein Tipp löst den normalen Button aus, damit Variante, Wunschname und Warenkorb genauso laufen wie dort
   - Text und Status (ausverkauft, lädt) folgen dem normalen Button
   - Pflichtfelder der Options-App (BCPO): Das Formular prüft sie nicht (novalidate), ohne Prüfung käme das Produkt
     ohne Wunschname in den Warenkorb. Die Prüfung sitzt deshalb am normalen Button und gilt für beide Buttons. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-ss-sticky-atc]');
  if (!bar || bar.getAttribute('data-ready')) return;
  bar.setAttribute('data-ready', '1');
  if (bar.closest('quick-add-modal, .quick-add-modal')) { bar.remove(); return; }

  var targetId = bar.getAttribute('data-target');
  var button = bar.querySelector('button');
  var label = bar.querySelector('[data-ss-sticky-label]');
  var current = null;
  var header = document.querySelector('.section-header');
  var headerHeight = header ? header.offsetHeight : 0;

  function main() { return document.getElementById(targetId); }

  function isVisible(el) { return el.getClientRects().length > 0; }

  function missingField(submit) {
    var scope = submit.closest('.product__info-container') || document;
    var fields = scope.querySelectorAll('#bcpo [required]');
    for (var i = 0; i < fields.length; i++) {
      if (isVisible(fields[i]) && !fields[i].checkValidity()) return fields[i];
    }
    return null;
  }

  function fieldName(field) {
    var el = document.getElementById(field.getAttribute('aria-labelledby') || '');
    return el ? el.textContent.replace(/[:*\s]+$/, '').trim() : '';
  }

  function clearError(field) {
    field.classList.remove('ss-field-invalid');
    var note = field.parentNode.querySelector('.ss-field-error');
    if (note) note.remove();
  }

  function report(field) {
    clearError(field);
    var note = document.createElement('p');
    var name = fieldName(field);
    note.className = 'ss-field-error';
    note.setAttribute('role', 'alert');
    note.textContent = name ? 'Bitte fülle zuerst dieses Feld aus: ' + name : 'Bitte fülle zuerst dieses Feld aus.';
    field.classList.add('ss-field-invalid');
    field.parentNode.insertBefore(note, field.nextSibling);
    field.addEventListener('input', function () { clearError(field); }, { once: true });
    field.addEventListener('change', function () { clearError(field); }, { once: true });
    field.focus({ preventScroll: true });
    field.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  // Capture-Phase: läuft vor dem Absenden, auch bei Enter im Namensfeld
  document.addEventListener('click', function (e) {
    var submit = e.target.closest && e.target.closest('#' + CSS.escape(targetId));
    if (!submit || submit.disabled) return;
    var field = missingField(submit);
    if (!field) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    report(field);
  }, true);

  // Die schwebende KI-Blase (fremde App, z-index 91050) läge sonst über dem Button: solange er sichtbar ist, rückt sie nach oben
  function liftAssistant(tries) {
    var show = bar.classList.contains('is-visible');
    var host = document.getElementById('ads-agent-host');
    if (!host || !host.shadowRoot) {
      if (show && tries < 10) setTimeout(function () { liftAssistant(tries + 1); }, 1000);
      return;
    }
    if (!host.shadowRoot.getElementById('ss-sticky-lift')) {
      var style = document.createElement('style');
      style.id = 'ss-sticky-lift';
      style.textContent = ':host([data-ss-sticky]) .fixed.cursor-pointer.touch-none { translate: 0 -64px; }';
      host.shadowRoot.appendChild(style);
    }
    host.toggleAttribute('data-ss-sticky', show);
  }

  function setShown(show) {
    bar.classList.toggle('is-visible', show);
    document.body.classList.toggle('ss-sticky-atc-on', show);
    liftAssistant(0);
  }

  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[entries.length - 1];
    setShown(!entry.isIntersecting && entry.boundingClientRect.bottom <= headerHeight);
  }, { rootMargin: '-' + headerHeight + 'px 0px 0px 0px' });

  function sync() {
    var m = main();
    if (!m) return;
    if (m !== current) {
      if (current) observer.unobserve(current);
      observer.observe(m);
      current = m;
    }
    var text = m.querySelector('span');
    if (text) label.textContent = text.textContent.trim();
    button.disabled = m.disabled || m.getAttribute('aria-disabled') === 'true';
  }

  button.addEventListener('click', function () {
    var m = main();
    if (m) m.click();
  });

  document.body.appendChild(bar);
  sync();

  // Variantenwechsel und Ladezustand des normalen Buttons übernehmen
  var form = current && current.closest('product-form');
  if (form) {
    new MutationObserver(sync).observe(form, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  }
})();
